import { render, staticRenderFns } from "./legalPersonIdentify.vue?vue&type=template&id=6a3bc1a9&scoped=true"
import script from "./legalPersonIdentify.vue?vue&type=script&lang=js"
export * from "./legalPersonIdentify.vue?vue&type=script&lang=js"
import style0 from "./legalPersonIdentify.vue?vue&type=style&index=0&id=6a3bc1a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3bc1a9",
  null
  
)

export default component.exports